import classNames from 'classnames/bind';
import React from 'react';
import { RiFullscreenLine, RiCrosshairLine, RiScreenshot2Line } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import VWorldMap from '@/helpers/VWorldMap';
import { getCSSVariable } from '@/utils/theme';

const cx = classNames.bind(styles);

const MapTool = () => {
  const dispatch = useDispatch();
  const isShowShoots = useSelector((state) => state.map.isShowShoots);

  const toggleShoots = () => {
    dispatch(actions.map.toggleShoots());
  };

  const fitBounds = () => {
    VWorldMap.fitBounds();
  };

  const moveToCurrent = () => {
    window.navigator.geolocation.getCurrentPosition(({ coords }) => {
      VWorldMap.setCenter({ lng: coords.longitude, lat: coords.latitude });
    });
  };

  return (
    <div className={cx('group')}>
      <div className={cx(['button', { active: isShowShoots }])} onClick={toggleShoots}>
        <RiScreenshot2Line
          size={18}
          title={isShowShoots ? 'Hide Shoots' : 'Show Shoots'}
          color={isShowShoots ? getCSSVariable('--tint-color') : 'white'}
        />
      </div>
      <div className={cx('button')} onClick={fitBounds}>
        <RiFullscreenLine size={18} title="Fit Bounds" color="white" />
      </div>
      <div className={cx('button')} onClick={moveToCurrent}>
        <RiCrosshairLine size={18} title="Current Location" color="white" />
      </div>
    </div>
  );
};

export default MapTool;
